<template>
  <div
    class="mx-auto h-[2px] transform origin-center transition-transform duration-500 bg-primary-500"
    :style="{
      transform: isActive ? ' scaleX(1)' : ' scaleX(0)',
    }"
  ></div>
</template>

<script setup>
  // Imports
  import { computed } from 'vue'
  // Props
  const props = defineProps({
    modelValue: Boolean,
  })
  // Computed
  const isActive = computed(() => props.modelValue)
</script>
